import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import chevronLeft from '../../../assets/map-chevron-left.svg';
import BlockImg from '../../../components/generic/BlockImg';
import { px } from '../../../utils/px';

const ChevronImg = styled(BlockImg).attrs(props => ({
  width: px(5),
  height: px(12),
  src: chevronLeft,
  alt: props.flipped ? 'Rozwiń' : 'Zwiń',
}))`
  transition: transform 250ms ease ;
  transform: rotate(0deg);
  ${props => props.flipped && css`
    transform: rotate(180deg);
  `};
`;
ChevronImg.propTypes = {
  flipped: PropTypes.bool
};

export default ChevronImg;
